import React from "react";
import help_picture from "../../assets/images/help_image.png";
import Footer from "../Footer";
import NavbarHome from "../Components/Home/NavbarHome";
import { useState } from "react";
import * as Yup from "yup";
import { PostAPI } from "app/middleware";
import { toast } from "react-toastify";
import { Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";

function Help() {
  const [name, setName] = useState(null);
  const [email, setEmail] = useState(null);
  const [message, setMessage] = useState(null);
  const [type, setType] = useState(null);
  const [errors, setErrors] = useState([]);
  const navigate = useNavigate();

  const handleTypeChange = (e) => {
    setType(e.target.value);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    const schema = Yup.object().shape({
      name: Yup.string().required("Name is required"),
      message: Yup.string().required("Message is required"),
      email: Yup.string()
        .email("Email must be valid")
        .required("Email is required"),
        type: Yup.string().required("Type is required"),
    });
    try {
      await schema.validateSync(
        { name, message,email, type },
        { abortEarly: false }
      );
      // call your API to authenticate the user and redirect them to the appropriate page
      var data = {
        name: name,
        message: message,
        email: email,
        type: type,
      };
      const respData = await PostAPI(data, "auth/adminHelpCenter");
      if (respData.statusCode == 200) {
        toast.success(respData.message);
        navigate("/user/otp");

      } else {
        toast.error(respData.message);
      }
    } catch (err) {
      setErrors(err.errors);
    }
  };


  return (
    <div>
      <NavbarHome />
      <div className="container mt-5 mb-5">
        <div className="row">
          <div className="col-md-6 help_page">
            <h1>
              Let's get you
              <br /> some help!
            </h1>
            <h6>
              Have any issue? Send us an{" "}
              <span className="email-us">email.</span>
            </h6>
            <div className="img_wrapper_1">
              <img
                src={help_picture}
                alt="undraw-onboarding-o8mv-1"
                border={0}
              />
            </div>
          </div>
          <div className="col-md-6">
            <form className="help_page_form">
              <div className="form-group pt-3">
                <label htmlFor="list">Name</label>
                <input
                  type="text"
                  className="form-control"
                  id="list"
                  aria-describedby="emailHelp"
                  onChange={(e) => setName(e.target.value)}
                />
                  {errors.find((error) => error.includes("Name")) && (
                <Alert sx={{ my: 2 }} severity="error">
                  {errors.find((error) => error.includes("Name"))}
                </Alert>
              )}
              </div>
              <div className="form-group pt-3">
                <label htmlFor="tags">Email</label>
                <input type="text" className="form-control"
                 id="tags" 
                 onChange={(e) => setEmail(e.target.value)}
                 />
                   {errors.find((error) => error.includes("Email")) && (
                <Alert sx={{ my: 2 }} severity="error">
                  {errors.find((error) => error.includes("Email"))}
                </Alert>
              )}
              </div>
              <div className="form-group pt-3">
                <label htmlFor="describe">Message</label>
                <textarea
                  type="text"
                  className="form-control"
                  id="describe"
                  rows={5}
                  defaultValue={""}
                  onChange={(e) => setMessage(e.target.value)}
                />
                 {errors.find((error) => error.includes("Message")) && (
                <Alert sx={{ my: 2 }} severity="error">
                  {errors.find((error) => error.includes("Message"))}
                </Alert>
              )}
              </div>
              <div className="form-group pt-3">
                <label htmlFor="exampleFormControlSelect1">Select Type</label>
                <select
                  className="form-control"
                  id="exampleFormControlSelect1"
                  onChange={handleTypeChange}
                  value={type}
                >
                  <option value="">Select Type</option>
                  <option value="Appointment">Appointment</option>
                  <option value="Product">Product</option>
                  <option value="Other">Other</option>
                </select>
                {errors.find((error) => error.includes("Type")) && (
                <Alert sx={{ my: 2 }} severity="error">
                  {errors.find((error) => error.includes("Type"))}
                </Alert>
                  )}
              </div>
              <button
                type="button"
                className="btn btn-primary mt-4 d-block mx-auto"
                onClick={handleSubmit}
              >
                <span>Submit</span>
                <i className="fas fa-long-arrow-alt-right" />
              </button>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Help;
